module.exports = __webpack_public_path__ + "static/media/31-arrangement.4f8075be.mp3";